import React from "react";

const PublishedByOthersIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35.645"
      height="35.675"
      viewBox="0 0 35.645 35.675"
    >
      <path
        id="db90"
        d="M214.477,225.041l11.371-32.806a1.421,1.421,0,0,0-1.805-1.82l-32.821,11.371a1.422,1.422,0,0,0,0,2.672l13.632,4.932,4.975-4.918a2.132,2.132,0,1,1,1.976,2.047l-4.932,4.918,4.918,13.632a1.422,1.422,0,0,0,2.687-.028Z"
        transform="translate(-190.285 -190.336)"
        fill={fill ? fill : "#70fb34"}
      />
    </svg>
  );
};

export default PublishedByOthersIcon;
